import React from 'react';
import { ShieldIcon, EncryptionIcon, CloudIcon, ProfileIcon } from './icons';

interface FeatureCardProps {
    icon: React.ReactNode;
    title: string;
    children: React.ReactNode;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, children }) => (
    <div className="bg-light-surface dark:bg-surface p-6 rounded-lg border border-light-border dark:border-border text-center flex flex-col items-center">
        <div className="mb-4 text-primary dark:text-secondary">
            {icon}
        </div>
        <h3 className="text-lg font-bold text-light-text-primary dark:text-text-primary mb-2">{title}</h3>
        <p className="text-sm text-light-text-secondary dark:text-text-secondary">
            {children}
        </p>
    </div>
);


const SecurityFeatures: React.FC = () => {
    return (
        <div className="bg-light-background dark:bg-background py-12 px-4">
            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl font-bold text-center text-light-text-primary dark:text-text-primary mb-2">Tu Seguridad es Nuestra Prioridad</h2>
                <p className="text-center text-light-text-secondary dark:text-text-secondary mb-8">
                    Entendemos que tus datos financieros son tu información más sensible. Por eso, hemos construido nuestra plataforma con la seguridad y la privacidad como pilares fundamentales.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <FeatureCard
                        icon={<EncryptionIcon className="w-10 h-10" />}
                        title="RGPD"
                    >
                        Tus datos están protegidos bajo el Reglamento General de Protección de Datos (RGPD) de la UE, una de las leyes de privacidad más estrictas del mundo.
                    </FeatureCard>
                     <FeatureCard
                        icon={<ShieldIcon className="w-10 h-10" />}
                        title="Cifrado de Nivel Bancario"
                    >
                        Toda la comunicación está protegida con cifrado HTTPS/TLS y tus datos se almacenan con cifrado AES-256, el mismo estándar que usan los bancos.
                    </FeatureCard>
                    <FeatureCard
                        icon={<CloudIcon className="w-10 h-10" />}
                        title="Infraestructura de Google"
                    >
                        La app se ejecuta en Google Cloud (Firebase), una infraestructura que cumple con los más altos estándares de seguridad como ISO 27001 y SOC 2.
                    </FeatureCard>
                     <FeatureCard
                        icon={<ProfileIcon className="w-10 h-10" />}
                        title="Tus Datos son Tuyos"
                    >
                        Solo tú tienes acceso a tus datos. Solo tú puedes verlos, crearlos, editarlos y borrarlos.
                    </FeatureCard>
                </div>
            </div>
        </div>
    );
};

export default SecurityFeatures;
